{
    "columns":[
		{
			"header_id": "tasBillingBatchMasterId",
			"header_label": "Batch master Id",
			"jsonpath":  "tasBillingBatchMasterId" ,
			"isDisplayedAtHeader": "y",
			"isSearchable": "y"
		},
		{
			"header_id": "tasBillingBatchFileMasterId",
			"header_label": "Batch file master Id",
			"jsonpath":  "tasBillingBatchFileMasterId" ,
			"isDisplayedAtHeader": "y",
			"isSearchable": "y"
		},
		{
			"header_id": "fileName",
			"header_label": "File Name",
			"jsonpath":  "fileName" ,
			"isDisplayedAtHeader": "y",
			"isSearchable": "n"
		},
		{
			"header_id": "fileType",
			"header_label": "File Type",
			"jsonpath":  "fileType" ,
			"isDisplayedAtHeader": "y",
			"isSearchable": "y"
		},
		{
			"header_id": "fileStatus",
			"header_label": "File Status",
			"jsonpath":  "fileStatus" ,
			"isDisplayedAtHeader": "y",
			"isSearchable": "y"
		},
		{
			"header_id": "recordCount",
			"header_label": "Record count",
			"jsonpath":  "recordCount" ,
			"isDisplayedAtHeader": "y",
			"isSearchable": "y"
		},
		{
			"header_id": "mcoCount",
			"header_label": "MCO count",
			"jsonpath":  "mcoCount" ,
			"isDisplayedAtHeader": "y",
			"isSearchable": "y"
		}
    ],
	"buttons": [],
    "apiDetails": "files.json",
	"pageName": "billingFileListView",
	"orderByColumn": ["tasBillingBatchFileMasterId"],
	"orderBy": ["desc"]
}